import { Controller, FieldValues, useController } from 'react-hook-form';

import { Label } from '@/components/UI/Label/Label';
import { SwitchComponent } from '@/components/UI/Switch/Switch';

import { FieldError } from '../FieldError';
import { FieldProps } from '../types';

type SwitchFieldProps<T extends FieldValues> = FieldProps<T> &
  Omit<React.ComponentPropsWithoutRef<typeof SwitchComponent>, keyof FieldProps<T>>;

export const SwitchField = <T extends FieldValues>({
  control,
  name,
  label,
  subLabel,
  required,
  rules,
  defaultValue,
  ...rest
}: SwitchFieldProps<T>) => {
  const { fieldState } = useController<T>({
    name,
    control,
    rules: { required: required ? 'dit veld is verplicht' : undefined, ...rules },
    defaultValue,
  });
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
      <div>
        {label && <Label>{label}</Label>}
        {subLabel && (
          <div style={{ marginTop: '-4px', fontSize: 'xs', color: 'var(--tractie-color-content-subtle)' }}>
            {subLabel}
          </div>
        )}
      </div>
      <div style={{ justifyContent: 'flex-end', cursor: 'pointer' }}>
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue}
          render={({ field }) => <SwitchComponent defaultValue={defaultValue} {...field} {...rest} />}
        />
        <FieldError width='auto' error={fieldState.error} />
      </div>
    </div>
  );
};
